import { Divider } from '@fox/atoms/src/divider/index';
import { Typography } from '@fox/atoms/src/typography/index';
import { formatCurrencyFromMinorUnits } from '@fox/finance/src/helpers';
import { useFormPaymentContext } from '@fox/finance/src/components/form-payment-context';
import { FlexColumnSpaced, FlexRowSpacedRightAligned, FlexWrapRowSpaced } from '@fox/layout/src/flex';
import { FormRenderMode, QuestionStyle } from '../../form-runtime-context/contracts';
import { useFormRuntimeContext } from '../../form-runtime-context/form-runtime-context';
import { TaxRatesData } from './contracts';
import PaymentSectionSummary from './payment-section-summary';

interface PaymentTotalsSummaryProps {
	labelStyles: Record<string, QuestionStyle>;
	defaultCurrency?: string;
	taxRates?: TaxRatesData | null;
}

const PaymentTotalsSummary = ({ labelStyles, defaultCurrency, taxRates }: PaymentTotalsSummaryProps) => {
	const { formRenderMode } = useFormRuntimeContext();
	const { grandTotal, lineItemsDataImmediate, lineItemsDataNotImmediate, totalPayImmediate, totalPayNotImmediate } = useFormPaymentContext();

	return (
		<FlexColumnSpaced>
			{formRenderMode === FormRenderMode.design ? null : (
				<FlexWrapRowSpaced>
					{lineItemsDataNotImmediate.length > 0 ? (
						<PaymentSectionSummary
							labelStyles={labelStyles}
							lineItems={lineItemsDataNotImmediate}
							summaryLabel="Due Later"
							total={totalPayNotImmediate}
							defaultCurrency={defaultCurrency}
							taxRates={taxRates}
						/>
					) : null}
					{lineItemsDataImmediate.length > 0 ? (
						<PaymentSectionSummary
							labelStyles={labelStyles}
							lineItems={lineItemsDataImmediate}
							summaryLabel="Due Now"
							total={totalPayImmediate}
							defaultCurrency={defaultCurrency}
							taxRates={taxRates}
						/>
					) : null}
				</FlexWrapRowSpaced>
			)}
			{lineItemsDataNotImmediate.length > 0 && lineItemsDataImmediate.length > 0 ? (
				<>
					<Divider orientation="horizontal" />
					<FlexRowSpacedRightAligned>
						<Typography sx={labelStyles} textAlign={'right'}>
							Grand Total: {formatCurrencyFromMinorUnits(grandTotal, defaultCurrency)}
						</Typography>
					</FlexRowSpacedRightAligned>
				</>
			) : null}
		</FlexColumnSpaced>
	);
};

export default PaymentTotalsSummary;
